const REDUCER = "@FOLLOWER/";

const actions = {
  GET_LIST_FOLLOWER: `${REDUCER}GET_LIST_FOLLOWER`,
  SET_LIST_FOLLOWER: `${REDUCER}SET_LIST_FOLLOWER`,
  SET_IS_LOADING: `${REDUCER}SET_IS_LOADING`,
  SET_CURRENT_FOLLOWER: `${REDUCER}SET_CURRENT_FOLLOWER`,
};
export default actions;
